import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-693ac6ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"max-width":"1440px","margin":"0 auto","margin-top":"32px","height":"800px"} }
const _hoisted_2 = ["src"]

import { getDataStatisticsIds } from "@/api/dataStatistics";
import { onMounted, ref } from "vue";
import { encryptedData, decryptedData } from "@/utils/rsa";

export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyPerspective',
  setup(__props) {

//弹福
const iframeUrl = ref("https://bi.onehome.cn/link/y4QlmZ0n");
onMounted(() => {
  getIds();
});

const getIds = async () => {
  let res: any = await getDataStatisticsIds({});
  if (res.code == 200) {
    let params = `{"contract_id":${res.data.contractId},"customer_id":${res.data.customerId}}`;
    let encryptedParams = encodeURIComponent(encryptedData(params));
    iframeUrl.value = iframeUrl.value + "?attachParams=" + encryptedParams;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: iframeUrl.value,
      width: "100%",
      height: "800px",
      scrolling: "auto",
      style: {"border":"none","overflow":"auto"}
    }, null, 8, _hoisted_2)
  ]))
}
}

})